module.exports = __webpack_public_path__ + "img/07.f8e85d8d.jpg";